module.exports = __webpack_public_path__ + "static/media/sf-steuart-4.a90f8945.png";